import { render } from "./LegalPageLayout.vue?vue&type=template&id=f83bbf74&scoped=true"
import script from "./LegalPageLayout.vue?vue&type=script&lang=js"
export * from "./LegalPageLayout.vue?vue&type=script&lang=js"

import "./LegalPageLayout.vue?vue&type=style&index=0&id=f83bbf74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f83bbf74"]])

export default __exports__